module.exports = __webpack_public_path__ + "img/right-arrow.d6554c74.svg";